<template>
    <div id="container">
        <div class="content">
            <h1>名师工作室入驻条件</h1>
            <p style="margin-bottom:10px">为了确保“名师工作室”栏目能够吸引和汇聚优质的高中教育资源，平台制定了以下入驻条件。请有意向的高中教师仔细阅读并确认是否符合要求</p>
            <h2>一、基本条件</h2>
            <p>1、教师资格</p>
            <p>（1）申请人必须持有有效的高中教师资格证。</p>
            <p>（2）申请人需在高中教学领域有至少 5年及以上 的教学经验。</p>
            <p>2、教学成果</p>
            <p>申请人在教学领域需有一定的成果，例如：</p>
            <p>（1）所带班级成绩优异，或在高考中取得突出成绩。</p>
            <p>（2）曾获得市级及以上教学荣誉或奖项。</p>
            <p>（3）发表过教学相关论文或出版过教学相关书籍。</p>
            <p>3、资源质量</p>
            <p>（1）提供的教学资源（如课件、教案、习题、视频等）需为原创，且符合国家教育政策和课程标准。</p>
            <p>（2）资源内容需具有创新性、实用性和可推广性，能够帮助学生提升学习效果。</p>
            <p>4、合作意愿</p>
            <p>申请人需同意平台对其提供的资源进行审核、购买和上传，并授予平台在指定范围内使用资源的权利。</p>
            <h2>二、资源要求</h2>
            <p>1、资源类型</p>
            <p>（1）课件（PPT、PDF等格式）</p>
            <p>（1）课件（PPT、PDF等格式）</p>
            <p>（3）试卷（含答案解析）</p>
            <p>（4）教学视频（高清、内容完整）</p>
            <p>（5）其他辅助教学资源（如思维导图、学习笔记等）</p>
            <p>2、资源标准</p>
            <p>（1）内容需符合高中课程标准，覆盖主要学科（语文、英语）。</p>
            <p>（2）资源需结构清晰、逻辑严谨，适合学生自学或教师参考。</p>
            <p>（3）视频资源需画面清晰、声音清楚，时长适中（建议每节视频时长在10-30分钟）。</p>
            <p>3、资源数量</p>
            <p>（1）首次入驻需提供至少 10份 高质量教学资源（如5份课件+3份习题+2节视频）。</p>
            <p>（2）后续需定期更新资源，每月至少上传 2份 新资源。</p>
            <h2>三、入驻流程</h2>
            <p>1、提交申请</p>
            <p>（1）登录平台，进入“名师工作室”栏目，点击“申请入驻”。（或直接联系客服）</p>
            <p>（2）添加客服，提交个人信息、教学经历、教学成果等内容，并上传相关证明材料（如教师资格证、荣誉证书等）。</p>
            <p>2、资源提交、审核</p>
            <p>（1）根据客服提供的资源需求列表提交教学资源作为初审材料。</p>
            <p>（2）审核通过后客服上传至平台，平台将与申请人签订合作协议并进行费用结算。</p>
            <p>3、正式入驻</p>
            <p>平台将为名师开设专属工作室页面，展示名师简介、教学成果和资源。</p>
            <h2>四、资源购买与收益</h2>
            <p>1、资源购买</p>
            <p>（1）平台将对名师提交的资源进行评估，并根据资源的质量、数量和市场价值进行定价购买。</p>
            <p>（2）购买方式包括一次性买断或按下载量分成，具体方式以合作协议为准。</p>
            <p>2、收益结算</p>
            <p>（1）平台将根据合作协议定期结算收益，结算周期为每月一次。</p>
            <p>（2）收益将通过银行转账形式发放。</p>
            <h2>五、名师权益</h2>
            <p>1、品牌曝光</p>
            <p>（1）平台将为入驻名师提供专属展示页面，提升名师知名度。</p>
            <p>（2）优秀名师将有机会参与平台的宣传推广活动。</p>
            <p>2、资源保护</p>
            <p>（1）平台将对名师提供的资源进行版权保护，未经授权不得转载或商用。</p>
            <p>3、优先合作</p>
            <p>（1）入驻名师可优先参与平台的教研活动、课程开发等项目。</p>
            <h2>六、退出机制</h2>
            <p>1、主动退出</p>
            <p>（1）名师可随时申请退出“名师工作室”，但需提前 30天 通知平台。</p>
            <p>（2）退出后，平台仍可继续展示已购买资源。</p>
            <p>2、平台终止合作</p>
            <p>（1）如名师提供的资源不符合平台要求，或存在侵权行为，平台有权终止合作。</p>
            <div class="sq" @click="dialogTableVisible = true">申请入驻</div>
        </div>
        <el-dialog
            title=""
            :visible.sync="dialogTableVisible"
            center
            width="640px"
        >
            <h2 class="tcTitle">免费入驻名师工作室</h2>
            <div class="jindu">
                <img src="../../assets/img/5.0/lc1.png" alt="">
                <p class="bz1">1.在线提交申请</p>
                <p class="bz2">2.添加客服微信审核</p>
                <p class="bz3">3.成功入驻</p>
            </div>
            <div class="chose">
                <div class="lie">
                    <div class="left">地区</div>
                    <div class="right">
                        <div class="adreess" ref="box">
                            <div class="indput" @click="choseSSQ = !choseSSQ" >
                                <input type="text"  :value="adreess"/>
                                <i class="el-icon-arrow-down jiantou" v-if="!choseSSQ"></i>
                                <i class="el-icon-arrow-up jiantou" v-if="choseSSQ"></i>
                            </div>
                            <div class="adreessBox" v-show="choseSSQ">
                                <div class="preBox box">
                                    <div
                                        class="list"
                                        v-for="item in provincecodeList"
                                        :key="item.code"
                                        @click="chosePre(item.code, item.name)"
                                        :class="{ select_color: provincecode == item.code }"
                                        >
                                        <span>{{ item.name }}</span>
                                        <i class="el-icon-arrow-right"></i>
                                    </div>
                                </div>
                                <div class="cityBox box" v-if="cityList.length > 0">
                                    <div
                                        class="list"
                                        v-for="item in cityList"
                                        :key="item.code"
                                        @click="choseCity(item.code, item.name)"
                                        :class="{ select_color: citycode == item.code }"
                                    >
                                        <span>{{ item.name }}</span>
                                        <i class="el-icon-arrow-right"></i>
                                    </div>
                                </div>
                                <div class="areaBox box" v-if="areaList.length > 0">
                                    <div
                                        class="list"
                                        v-for="item in areaList"
                                        :key="item.code"
                                        @click="choseArea(item.code, item.name)"
                                        :class="{ select_color: areacode == item.code }"
                                    >
                                        <span>{{ item.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="lie">
                    <div class="left">学校</div>
                    <div class="right">
                        <el-select
                            v-model="school"
                            filterable
                            allow-create
                            placeholder="请选择"
                            @change="changeSchool"
                        >
                            <el-option
                            v-for="item in schoolList"
                            :key="item.id"
                            :label="item.title"
                            :value="item.title"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="lie">
                    <div class="left">姓名</div>
                    <div class="right">
                        <input v-model="true_name" placeholder="请填写真实姓名" />
                    </div>
                </div>
                <div class="lie">
                    <div class="left">手机号</div>
                    <div class="right">
                        <input v-model="account" placeholder="请输入手机号码" />
                    </div>
                </div>
                <div class="lie">
                    <div class="left">验证码</div>
                    <div class="right">
                        <input v-model="msg_verf" placeholder="请输入验证码" />
                        <span class="getYzm" @click="getDx" v-if="!djsShow">获取验证码</span>
                        <span class="getYzm" v-if="djsShow">重新发送 {{ countdown }}s</span>
                    </div>
                </div>
            </div>
            <div class="submit" @click="submit">
                提交申请
            </div>
        </el-dialog>
        <el-dialog
            title=""
            :visible.sync="dialogTableVisible2"
            center
            width="640px"
        >
            <h2 class="tcTitle">免费入驻名师工作室</h2>
            <div class="jindu">
                <img src="../../assets/img/5.0/lc2.png" alt="">
                <p class="bz1">1.在线提交申请</p>
                <p class="bz2" style="color:#FFF;">2.添加客服微信审核</p>
                <p class="bz3">3.成功入驻</p>
            </div>
            <div class="evm">
                <img :src="evm_file_url" alt="">
            </div>
            <div class="tips">添加工作人员微信，完成审核</div>
        </el-dialog>
    </div>
</template>
<script>
import {
  userinfo,
  nianjilists,
  school,
  pca,
  list_systypes,
  setuserinfo,
  nowkemu,
  qiniuconfig,
  checkschool,
  sendverf,
  add_starteacherstudio,
} from "../../api/http";
export default {
  metaInfo () {
    return {
      title: '精准教研教学平台-专注教师教研与教学服务，助力教师专业提升！',
       meta: [{ 
        name: 'Keywords',
        content: '教研教学平台,教学资源,同步教研,课件下载,同步课件,备课资源,教师培训,教师研修,人教版课件,在线教研,新高考'
      }, {
        name: 'description',
        content: '精准教研教学平台是一个专门为全国高中教师打造的教研教学服务平台，侧重高中教材同步精品资源下载（课件、教案、学案、试卷、素材、练习等）、体系化公益教研活动直播、专家名师工作室优质资源共享等。精准定位教学需求，助力提升教学水平，是高中教师随时随地的教研教学小助手。'
      }],
    }
  },
  data(){
    return{
        dialogTableVisible:false,
        dialogTableVisible2:false,
        true_name:'',
        account:'',
        adreess:this.province? (this.province = ""
        ? "请选择所在的省市区"
        : this.province + "/" + this.city + "/" + this.area):'请选择所在省市区', //所在省市区
        provincecode: "", //省id
        citycode: "", //市id
        areacode: "", //区id
        province: "", //省名称
        city: "", //市名称
        area: "", //区名称
        school: "", //所在学校
        school_id: "", //学校id
        choseSSQ: false, //省市区选择框的显示隐藏
        schoolList: [], //可选学校列表
        provincecodeList: [], //省列表
        cityList: [], //市列表
        areaList: [], //区列表
        msg_verf:'',
        djsShow: false, //重新发送倒计时显示隐藏
        countdown: 60, //短信验证码再次发送倒计时
        dxTimer: null, //重新获取验证码倒计时
        evm_file_url:'',
    }
  },
  created(){
    $(document).ready(function () {
      $(window).scrollTop(0);
    });
    //获取省市区数据
    pca({
      type: "p",
    }).then((res) => {
      console.log(res, "省份数据 ");
      this.provincecodeList = res.retRes;
    });
  },
  mounted() {
    //点击某元素以外的任何区域
    document.addEventListener("click", this.dosome);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.dosome);
  },
  methods:{
    submit(){
        console.log(this.account,this.provincecode,this.true_name,this.school)
        if(!this.account){
            this.$message('请填写手机号')
        }else if(!this.msg_verf){
            this.$message('请填写验证码')
        }else{
            add_starteacherstudio({
                md5key: localStorage.getItem("md5key"),
                account:this.account,
                msg_verf:this.msg_verf,
                school_title:this.school,
                true_name:this.true_name,
                provincecode:this.provincecode,
                citycode:this.citycode,
                areacode:this.areacode,
            }).then(res=>{
                if(res.retInt == 1){
                  this.dialogTableVisible = false
                  this.evm_file_url = res.retRes;
                  this.dialogTableVisible2 = true
                }
            })
        }
    },
    dosome(e) {
      // console.log(this.$refs.box.contains(e.target))
      if (!this.$refs.box.contains(e.target)) {
        this.choseSSQ = false; //这句话的意思是点击其他区域关闭（也可以根据自己需求写触发事件）
        // console.log(123)
      }
    },
    //选择省
    chosePre(code, name) {
      console.log(code);
      this.provincecode = code;
      this.province = name + "/";
      this.citycode = "";
      this.city = "";
      this.areacode = "";
      this.area = "";
      this.areaList = [];
      pca({
        type: "c",
        pcode: this.provincecode,
      }).then((res) => {
        console.log(res, "城市数据 ");
        this.cityList = res.retRes;
      });
    },
    //选择市
    choseCity(code, name) {
      this.citycode = code;
      this.city = name + "/";
      this.areacode = "";
      this.area = "";
      pca({
        type: "a",
        pcode: this.citycode,
      }).then((res) => {
        console.log(res, "地区数据 ");
        this.areaList = res.retRes;
      });
    },
    //选择区
    choseArea(code, name) {
      this.areacode = code;
      this.area = name;
      this.choseSSQ = false;
      this.adreess = this.province + this.city + this.area;
      school({
        provincecode: this.provincecode,
        citycode: this.citycode,
        areacode: this.areacode,
      }).then((res) => {
        this.schoolList = [];
        console.log(res, "学校列表");
        if (res.retInt == 1) {
          const data = res.retRes;
          this.schoolList = data;
          // this.schoolList.unshift({id:0,title:'手动输入'})
        } else if (res.retInt != 1) {
          this.$notify.error({
            title: "错误",
            message: res.retErr,
            duration: 2000,
            showClose: false,
          });
        }
      });
    },
    //选择学校
    changeSchool(e) {
      console.log(e, typeof this.school, this.school);
      if (typeof this.school == "string") {
        console.log("不存在的学校");
        console.log(this.school_id);
        //输入的不存在的学校就查询并创建
        if (this.provincecode == "") {
          this.$notify.error({
            title: "错误",
            message: "请先选择省市区",
            duration: 2000,
            showClose: false,
          });
        } else {
          checkschool({
            md5key: localStorage.getItem("md5key"),
            provincecode: this.provincecode,
            citycode: this.citycode,
            areacode: this.areacode,
            title: this.school,
          }).then((res) => {
            if (res.retInt == 1) {
              console.log(res, "创建学校");
              this.school_id = res.retRes.id;
            } else {
              this.$notify.error({
                title: "错误",
                message: res.retErr,
                duration: 2000,
                showClose: false,
              });
            }
          });
        }
      } else if (typeof this.school == "number") {
        console.log("已存在的学校");
        this.school_id = e;
      }
    },
    //获取短信验证码
    getDx() {
      //电话号码正则验证，如果通过就发送验证码
      const reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      const reg_yzm = /^\d{6}$/;
      if (this.account.trim() == "") {
        // this.errorPn = true;
        // this.errorMsgPn = "请填写手机号";
        this.$message('请填写手机号')
      } else if (!reg_tel.test(this.account)) {
        // this.errorPn = true;
        // this.errorMsgPn = "手机号格式错误";
        this.$message('手机号格式错误')
      } else {
        //手机号码正常，发送短信验证码并倒计时60秒后才可重新发送
        sendverf({
          phone: this.account ? this.account : "",
        }).then((res) => {
          if (res.retInt == 1) {
            this.dxTimer = setInterval(() => {
              if (this.countdown > 0 && this.countdown <= 60) {
                this.countdown--;
                if (this.countdown !== 0) {
                  this.djsShow = true;
                  console.log("daojishi");
                } else {
                  this.djsShow = false;
                  this.countdown = 60;
                  clearInterval(this.dxTimer);
                  console.log("倒计时");
                }
              }
            }, 1000);
          }
        });
      }
    },
  },
}
</script>
<style lang="less" scoped>
    #container{
        overflow: hidden;
        .content{
            margin: 20px auto;
            width: 1200px;
            height: 1725px;
            background: #FFFFFF;
            border-radius: 10px;
            overflow: hidden;
            h1{
                margin-bottom: 30px;
                margin-top: 30px;
                font-size: 20px;
                text-align: center;
            }
            h2{
                margin-bottom: 10px;
                margin-top: 10px;
                margin-left: 60px;
                font-size: 16px;
                color: #333333;
            }
            p{
                margin-left: 60px;
                font-size: 14px;
                color: #666666;
                line-height: 24px;
            }
            .sq{
                margin: 0 auto;
                margin-top: 40px;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 40px;
                text-align: center;
                width: 120px;
                height: 40px;
                background: #1E60EB;
                border-radius: 4px;
                cursor: pointer;
            }
            .sq:active{
                opacity: .8;
            }
        }
        .chose{
            margin: 0 auto;
            width: 440px;
            border-bottom: 1px solid #E6E6E6;
            .lie{
                position: relative;
                display: flex;
                align-items: center;
                width: 440px;
                // border-right: 1px solid #E6E6E6;
                border: 1px solid #E6E6E6;
                border-bottom: none;
                .left{
                    width: 120px;
                    height: 44px;
                    font-size: 14px;
                    line-height: 44px;
                    color: #646566;
                    text-align: center;
                    border-right: 1px solid #E6E6E6;
                }
                .right{
                    .getYzm{
                        position: absolute;
                        right: 14px;
                        top: 12px;
                        font-size: 14px;
                        color: #1E60EB;
                        cursor: pointer;
                    }
                    .getYzm:active{
                        opacity: .8;
                    }
                }
            }
        }
        .tcTitle{
            margin: 30px auto;
            margin-top: -30px;
            text-align: center;
            font-size: 18px;
            color: #333333;
        }
        .jindu{
            position: relative;
            margin-bottom: 30px;
            margin-left: 15px;
            width: 565px;
            p{
                position: absolute;
                font-size: 16px;
                
                color: #1E60EB;
                line-height: 24px;
            }
            .bz1{
                top: 12px;
                left: 34px;
                color: #FEFEFF !important;
            }
            .bz2{
                top: 12px;
                left: 216px;
            }
            .bz3{
                top: 12px;
                left: 430px;
            }
        }
        /deep/.el-dialog{
            border-radius: 20px;
        }
        .el-input {
            width: 295px;
            height: 40px;
            border: none;
        }
        .el-select {
            width: 310px;
            height: 40px;
            border: none;
            text-align: center;
        }
        .indput {
            position: relative;
            cursor: pointer;
        }
        /deep/.el-select .el-input__inner{
            width: 310px;
            height: 40px !important;
            border: none;
             text-align: center;
        }
        .el-select>.el-input{
            height: 40px;
            border: none;
             text-align: center;
        }
        input {
            padding-left: 15px;
            padding-right: 15px;
            color: #666;
            width: 260px;
            height: 40px;
            border: 0;
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            outline: none;
            background: #fff;
            cursor: pointer;
            border: none;
            text-align: center;
        }
        .adreess {
                position: relative;
                .select_color {
                    color: #08a579;
                    font-weight: 600;
                    i {
                    color: #08a579;
                    }
                }
                // .icon_style {
                //   transform: rotate(180deg);
                // }
                .adreessBox {
                    display: flex;
                    position: absolute;
                    top: 40px;
                    left: 0;
                    z-index: 1000;
                    background-color: #fff;
                    box-shadow: 0px 0px 20px 4px #ccc;
                    border-radius: 4px;
                    transition: 1s;
                    .box {
                    margin-top: 10px;
                    padding: 0px 15px 10px 40px;
                    width: 170px;
                    height: 250px;
                    -ms-overflow-style: none; /* IE 10+ */
                    scrollbar-width: none; /* Firefox */
                    overflow-y: scroll;
                    .list {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 40px;
                        cursor: pointer;
                    }
                    }
                    .preBox {
                    border-right: 1px solid #ccc;
                    }
                    .cityBox {
                    border-right: 1px solid #ccc;
                    }
                    ::-webkit-scrollbar {
                    display: none; /* Chrome Safari */
                    }
                }
        }
        .jiantou {
            position: absolute;
            top: 12px;
            right: -10px;
            color: #999;
            font-size: 15px;
        }
        .submit{
            margin: 0 auto;
            margin-top: 30px;
            width: 120px;
            height: 40px;
            background: #1E60EB;
            border-radius: 4px;
            color: #FFFFFF;
            font-size: 14px;
            line-height: 40px;
            text-align: center;
            cursor: pointer;
        }
        .evm{
            margin: 0 auto;
            width: 220px;
            height: 220px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .tips{
            text-align: center;
            margin-top: 20px;
            margin-bottom: 20px;
            font-size: 14px;
            color: #999999;
        }
        .el-input{
          width: 310px !important;
        }
        /deep/.el-input{
          width: 310px !important;
        }
    }
</style>
